import { images } from ".";

const offers = [
    { 
        id: 1, 
        image: images.offer1, 
        title: "Maldives Luxury Escape", 
        description: "All-Inclusive 5 Nights from $899", 
        link: "Tours" 
    },
    { 
        id: 2, 
        image: images.offer2, 
        title: "Mediterranean Cruise Special", 
        description: "Save $2,000 on Balcony Suites", 
        link: "Tours" 
    },
    { 
        id: 3, 
        image: images.offer3, 
        title: "Luxury Vacation Upgrade Offer", 
        description: "Get $1,000 Travel Credit on Premium Packages", 
        link: "Tours" 
    },
    { 
        id: 4, 
        image: images.offer4, 
        title: "Adventure Holidays up to 40% Off", 
        description: "Book Now & Save up to $5,000", 
        link: "Tours" 
    },
    { 
        id: 5, 
        image: images.offer5, 
        title: "Bali Retreat — Early Bird Offer", 
        description: "7 Days Wellness Package from $750", 
        link: "Tours" 
    },
    { 
        id: 6, 
        image: images.offer6, 
        title: "Last-Minute Dubai City Break", 
        description: "4 Nights Luxury Stay at $499", 
        link: "Tours" 
    },
];

export default offers;
